exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile_tips{opacity:0;pointer-events:none}@media (max-width: 600px){.mobile_tips{opacity:1;pointer-events:all;width:100vw;height:100vh;background-color:rgba(255,255,255,0.8)}}\n", ""]);

// exports
